import React from 'react';

export default function MixerBladeIcon({
  width = 64,
  height = 64,
  startColor = '#4c4c4c',
  midColor = '#b2b2b2',
  endColor = '#4c4c4c'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 391 391" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <path style={{fill: "#7f7f7f", stroke: "#4c4c4c", strokeWidth: "2"}} d="M342,391 l10,-1 9,-3 8,-4 8,-6 6,-8 4,-8 3,-9 1,-10 -1,-10 -3,-9 -4,-8 -6,-8 -8,-6 -8,-4 -9,-3 -10,-1 -146,49 146,49z" /><path style={{fill: "#999"}} d="M342,383 l10,-1 9,-2 8,-4 8,-5 6,-6 4,-7 3,-8 1,-8 -1,-8 -3,-8 -4,-7 -6,-6 -8,-5 -8,-4 -9,-2 -10,-1 -146,41 146,41z" /><ellipse style={{fill: "#b2b2b2"}} cx="293" cy="342" rx="97" ry="24" /><path style={{fill: "#7f7f7f", stroke: "#4c4c4c", strokeWidth: "2"}} d="M49,391 l-10,-1 -9,-3 -8,-4 -8,-6 -6,-8 -4,-8 -3,-9 -1,-10 1,-10 3,-9 4,-8 6,-8 8,-6 8,-4 9,-3 10,-1 147,49 -147,49z" /><path style={{fill: "#999"}} d="M49,383 l-10,-1 -9,-2 -8,-4 -8,-5 -6,-6 -4,-7 -3,-8 -1,-8 1,-8 3,-8 4,-7 6,-6 8,-5 8,-4 9,-2 10,-1 147,41 -147,41z" /><ellipse style={{fill: "#b2b2b2"}} cx="98" cy="342" rx="98" ry="24" /><path style={{fill: "#7f7f7f", stroke: "#4c4c4c", strokeWidth: "2"}} d="M217,318 l0,-318 -43,0 0,318 -5,5 -3,6 -2,6 -1,7 1,7 2,6 3,5 4,5 5,4 5,3 6,2 7,1 6,-1 6,-2 6,-3 4,-4 4,-5 3,-5 2,-6 1,-7 -1,-7 -2,-6 -3,-6 -5,-5z" /><path style={{fill: "#999"}} d="M215,317 l0,-313 -39,0 0,313 -4,4 -2,5 -2,6 -1,6 2,11 7,9 9,7 11,2 11,-2 9,-7 6,-9 2,-11 -1,-6 -2,-6 -2,-5 -4,-4z" /><path style={{fill: "#b2b2b2"}} d="M210,316 l0,-308 -29,0 0,308 -3,3 -3,4 -1,4 -1,5 2,8 5,7 7,5 9,2 9,-2 7,-5 4,-7 2,-8 -1,-5 -1,-4 -3,-4 -3,-3z" />
    
      </g>
      <rect x="0" y="0" width="391" height="391" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
